/* eslint-disable @next/next/no-img-element */
import classNames from '@sindresorhus/class-names';
import Link from 'next/link';

import {Orientation, SelectionApp} from '@web-catalog/types';

import {ROUTES} from '@web-catalog/routes';

import {Text} from '@web-catalog/ui-kit/Text';

import styles from './AppWithScreenshotsCard.module.scss';

type Props = {
  app: SelectionApp;
  onClick: () => void;
  className?: string;
};

export const AppWithScreenshotsCard = ({app, className, onClick}: Props) => {
  const screenshotsOrientation =
    app.screenshots[0].orientation || Orientation.PORTRAIT;
  const screenshotsSlice = app.screenshots.slice(
    0,
    screenshotsOrientation === Orientation.PORTRAIT ? 3 : 1,
  );

  return (
    <Link
      className={classNames(styles.root, className)}
      href={ROUTES.app.app(app.packageName)}
      prefetch={false}
      onClick={onClick}
      data-testid={`app-${app.packageName}`}
    >
      <div className={styles.top}>
        <img
          src={app.iconUrl}
          className={styles.icon}
          loading="lazy"
          alt={`${app.appName} логотип`}
        />
        <Text
          className={styles.title}
          typography="subheader-2"
          overflow="ellipsis"
          maxLines={1}
        >
          {app.appName}
        </Text>
        <Text
          className={styles.description}
          typography="content-s"
          overflow="ellipsis"
          maxLines={1}
        >
          {app.shortDescription}
        </Text>
      </div>
      <div
        className={classNames(
          styles.screenshots,
          screenshotsOrientation === Orientation.PORTRAIT
            ? styles.portrait
            : styles.landscape,
        )}
      >
        {screenshotsSlice.map((item, index) => (
          <img
            key={index}
            src={item.fileUrl}
            className={styles.screenshot}
            loading="lazy"
            alt={`${app.appName} - скрин ${index + 1}`}
            data-testid={`screenshot-${index}`}
          />
        ))}
      </div>
    </Link>
  );
};
